import {
  FETCH_LAYOUTS_FAILURE,
  FETCH_LAYOUTS_REQUEST,
  FETCH_LAYOUTS_SUCCESS,
  RESET_LAYOUTS_FILTER,
  SET_ALL_FILTERS,
  SET_LAYOUTS_FILTERS,
  SET_LAYOUTS_ITEMS,
} from './actionTypes'
import {
  FetchLayoutsFailurePayload,
  LayoutItemType,
  LayoutsFiltersPayloadType,
  LayoutsFilterType,
  ResetLayoutFilterType,
  SetAllFilters,
  SetLayoutsFiltersType,
} from './types'

export const FetchLayoutsRequest = ({ id }: { id: string }): any => ({
  type: FETCH_LAYOUTS_REQUEST,
  id,
})

export const FetchLayoutsSuccess = (payload: any): any => ({
  type: FETCH_LAYOUTS_SUCCESS,
  payload,
})

export const FetchLayoutsFailure = (
  payload: FetchLayoutsFailurePayload
): any => ({
  type: FETCH_LAYOUTS_FAILURE,
  payload,
})

export const SetLayoutsItems = (payload: LayoutItemType[]): any => ({
  type: SET_LAYOUTS_ITEMS,
  payload,
})

export const SetLayoutsFilter = (
  payload: LayoutsFiltersPayloadType
): SetLayoutsFiltersType => {
  return {
    type: SET_LAYOUTS_FILTERS,
    payload: { ...payload },
  }
}

export const resetLayoutsFilter = (): ResetLayoutFilterType => {
  return {
    type: RESET_LAYOUTS_FILTER,
  }
}

export const setAllFilters = (payload: LayoutsFilterType): SetAllFilters => {
  return {
    type: SET_ALL_FILTERS,
    payload,
  }
}
